const ApiUrl = {
  // account
  dashboardLogin: "/Users/Login",
  forgotPassword: "/Users/ForgotPassword",
  resetPassword: "/Users/ResetPassword/",
  setupMfa: "/Users/SetupMfa",
  confirmMfa: "/Users/ConfirmMfa",
  sendEmailMfaCode: "/Users/SendEmailMfaCode",

  // user
  addUser: "/Users/Create",
  getAllUser: "/Users/GetUsers",
  changePassword: "/Users/ChangePassword",
  signOutOtherDevices: "/Users/SignOutOtherDevices", // ROI-435
  deleteUser: "/Users/",
  updateUser: "/Users/Update",
  detailUser: "/Users/",
  resetMfa: "/Users/ResetMfa",

  // chatbot
  addChatbot: "/Chatbots/Create",
  updateChatbot: "/Chatbots/Update",
  updateChatbotAttachment: "/Chatbots/UpdateAttachment",
  manageChatbot: "/Chatbots/Manage",
  getChatbotById: "/Chatbots/",
  updatePublishStatus: "/Chatbots/UpdatePublishStatus",
  deleteChatbot: "/Chatbots/",
  detailLiveChatbot: "/Chatbots/DetailLink/",
  widgetChatbot: "/Chatbots/Widget/",
  detailTestChatbot: "/Chatbots/DetailLinkTest/",
  filter: "/Chatbots/Filter",

  //contact
  getCandidateDetails: "/Contacts/GetCandidate/",
  getCandidateAtsDetails: "/Contacts/GetCandidateAtsDetail/",
  getCandidateAtsDetailsByToken: "/Contacts/GetCandidateAtsDetailPublic/",
  getClientDetails: "/Contacts/GetClient/",
  getLeadDetails: "/Contacts/GetLead/",
  getAllCandidates: "/Contacts/GetCandidates",
  getAllJobProfiles: "/Jobs/GetJobs",
  getAllClients: "/Contacts/GetClients",
  getAllLeads: "/Contacts/GetLeads",
  getContactResume: "/Contacts/GetContactResume/",
  addContact: "/Contacts/Create",
  deleteContacts: "/Contacts/Delete",
  checkExistingEmail: "/Contacts/CheckEmail",
  checkExistingMobile: "/Contacts/CheckPhone",
  updateContact: "Contacts/Update",
  convertLead: "/Contacts/Convert",
  archiveOrRestoreLead: "/Contacts/ArchiveOrRestore",
  updateCandidateAts: "/Contacts/UpdateAtsCandidate/",
  updateCandidateAtsFromPublic: "/Contacts/UpdateAtsCandidatePublic/",
  unsubscribeCandidate: "/Unsubscribes/UnsubscribeCandidateDetail",
  unsubscribeClient: "/Unsubscribes/UnsubscribeClientDetail",

  //clients
  getClientAtsDetails: "/Contacts/Client/AtsDetail/",
  updateClientAts: "/Clients",

  //audience candidate
  getAudienceDetails: "/Audiences/GetAudienceDetail/",
  addAudience: "/Audiences/Create",
  updateAudience: "/Audiences/Update",
  getAllAudience: "/Audiences/GetAudiences",
  deleteAudience: "/Audiences/Delete",
  unsubscribeAudienceMember: "/Unsubscribes/UnsubscribeAudienceMember",
  deleteAudienceMember: "/AudienceMembers/Delete",
  unsubscribeAudienceMemberFromPublic: "/Unsubscribes/UnsubscribeFromEmail",

  //audience client
  getAudienceClientDetails: "/AudienceClients/",
  unsubscribeClientFromPublic: "/UnsubscribeClients/UnsubscribeFromPublic",
  unsubscribeClientFromAudience: "/UnsubscribeClients/UnsubscribeFromAudience/",

  //audience member
  addAudienceMembers: "/AudienceMembers/InsertAudienceMember",
  getAudienceMembers: "/AudienceMembers/",
  getAudienceClientMembers: "/AudienceClientMembers/",
  getContactList: "/AudienceMembers/GetContactList",

  //audienceClient
  getAudienceClients: "/AudienceClients",
  deleteAudienceClient: "/AudienceClients",

  //gridFilter
  getAllFilter: "/GridFilters/GetFilters",
  detailFilter: "/GridFilters/",
  addFilter: "/GridFilters/Create",
  updatefilter: "/GridFilters/Update,",
  deleteFilter: "/GridFilters/",

  //companies
  getAllCompany: "/Companies/GetCompanies",
  setCompanyAllowLogin: "/Companies/{id}/AllowLogin",
  setCompanyOperationalFlags: "/Companies/{id}/OperationalFlags",
  addCompany: "/Companies/Create",
  updateCompany: "/Companies/Update",
  validateMessageSetting: "/Companies/ValidateMessageSetting",
  setupCompanyCredentials: "/Companies/SetupCredentials",
  deleteCompany: "/Companies/",
  getCompanyById: "/Companies/",
  getCompanyByName: "/Companies/GetCompanyByName",
  atsAuthentication: "/Companies/AtsAuthentication",
  syncNow: "/Companies/SyncNow",
  syncFields: "/Companies/SyncFields",
  getCompanyAdditionalInfo: "/Companies/GetCompanyAdditionalInfo",
  getAtsProviders: "/Companies/AtsProviders",
  copyDefaultTemplates: "/Companies/CopyDefaultTemplates",
  addMissingAtsFields: "/Companies/AddMissingAtsFields",
  migrateCompanyAutomations: "/Companies", // POST /Companies/{id}/migrate
  importUnsubscribes: "/Unsubscribes/import", // POST /Unsubscribes/import/{companyId}
  bulkUnsubscribeByIds: "/Unsubscribes/BulkByIds",
  resubscribe: "/Unsubscribes/Resubscribe",
  adminEnvironmentInfo: "/AdminDashboard/EnvironmentInfo",
  seedTestData: "/AdminDashboard/SeedTestData",
  adminAuditLogs: "/AdminDashboard/AuditLogs",
  adminAuditLogActors: "/AdminDashboard/AuditLogActors",
  adminAlerts: "/AdminDashboard/Alerts",
  adminAlertConfigs: "/AdminDashboard/AlertConfigs",
  adminJaApiMetrics: "/AdminDashboard/JaApiMetrics",
  hangfireInfo: "/HangfireInfo",
  adminEmailOutbox: "/AdminDashboard/EmailOutbox",
  adminAutomations: "/AdminDashboard/Automations",
  adminIngests: "/AdminDashboard/Ingests",
  adminCompanyHealth: "/AdminDashboard/CompanyHealth",
  adminManualIngest: "/AdminDashboard/ManualIngest",

  //chatbotTemplate
  addChatbotTemplate: "/ChatbotTemplates/Create",

  //report
  getActivityLogs: "/ActivityLogs/GetActivityLogs/",
  getEmailReports: "/Reports/Emails/",
  getAllEmailReports: "/Reports/Emails/All",
  getEmailReportSelectedDetails: "/Reports/Email/",
  getEmailReportLink: "/Reports/Email/Link/",
  getEmailReportClicked: "/Reports/Emails/Clicked/",
  getEmailReportLinkDetails: "/Reports/Email/Link/Clicked",
  getSurveyReports: "/Reports/Survey",
  getSurveyGroupReports: "/Reports/SurveyGroup",
  getAllSurveyGroupReports: "/Reports/SurveyGroup/All",
  getAutomationReports: "/Reports/Automation/",
  getTextReports: "/Reports/Text/",
  getTextReportSelected: "/Reports/Texts/",
  getTextReportLink: "/Reports/Text/Link/",
  getTextReportLinkDetail: "/Reports/Text/Link/Clicked/",
  getTextReportClicked: "/Reports/Text/CLicked",
  getTextReportDelivered: "/Reports/Text/Delivered",
  getAllAutomationReports: "/Reports/Automation/All",
  getAutomationReportDetails: "/Reports/Automation/",
  getAutomationReportCompletions: "/Reports/Automation/StepDetail/",
  getAutomationReportClientCompletions: "/ReportClients/Automation/StepDetail/",
  getSurveyCompletion: "/Reports/SurveyCompletionDetail/",
  getSurveyCompletionReport: "/Reports/TotalCompletionSurvey",
  getSurveyOpenReport: "/Reports/TotalOpenSurvey",
  getSurveyReportTotalOpened: "/Reports/Survey/TotalOpened",
  getSurveyReportTotalCompletion: "/Reports/Survey/TotalCompletion",
  getSurveyCompletionResponses: "/Reports/SurveyCompletionResponses/",
  getSurveyReportCsv: "/Reports/Survey/Csv",

  //survey report clients
  getSurveyReportsClient: "/ReportClients/Survey",
  getSurveyGroupReportsClient: "/ReportClients/SurveyGroup",
  getSurveyClientCompletion: "/ReportClients/SurveyCompletionDetail/",
  getSurveyClientReportTotalOpened: "/ReportClients/Survey/TotalOpened",
  getSurveyClientReportTotalCompletion: "/ReportClients/Survey/TotalCompletion",
  getSurveyClientCompletionResponses: "/ReportClients/SurveyCompletionResponses/",
  getSurveyReportClientCsv: "/ReportClients/Survey/Csv",

  //report email clients
  getEmailClientReports: "/ReportClients/ClientEmails/",
  getEmailReportClientSelectedDetails: "/ReportClients/ClientEmail/",
  getEmailReportClientLink: "/ReportClients/ClientEmails/Link/",
  getEmailReportClientClicked: "ReportClients/ClientEmail/Clicked/",
  getEmailReportClientLinkDetails: "ReportClients/ClientEmail/Link/Clicked",
  getSurveyOpenReportClient: "/ReportClients/TotalOpenSurvey",
  getSurveyCompletionReportClient: "/ReportClients/TotalCompletionSurvey",

  //report automation client
  getAutomationClientReports: "ReportClients/Automation/Client",
  getAutomationReportClientDetails: "/ReportClients/Automation/Client/",

  //job
  addJob: "Jobs/Create",
  getAllJob: "Jobs/GetJobs/",
  getAllClientJob: "Jobs/GetClientJobs/",
  getJobDetails: "/Jobs/GetJobsDetail/",
  updateJob: "/Jobs/UpdateJobDetail",
  archiveOrRestoreJob: "/Jobs/ArchiveOrRestore/",
  getJobCandidate: "/Jobs/GetJobCandidates/",
  getCandidatesForJob: "Jobs/GetCandidatesForJob/",
  addCandidateToJob: "/Jobs/AddcandidateToJob",
  searchJobsForAutomation: "/Jobs/SearchForAutomation",

  //campaign
  sendCampaign: "/Campaign/Send",
  sendCampaignClient: "/Campaign/SendClient",
  getCampaignByType: "/ActivityLogs/GetCampaignByFeatureType/",
  sendTestMail: "/Campaign/SendTestMail",
  newSendTestMail: "/Campaign/NewSendTestMail",
  sendTestAlert: "/Alert/SendTestAlert",

  //acvitityLog
  getContactActivity: "/ActivityLogs/GetContactActivityLogs/",
  getClientActivity: "/ActivityLogs/Client/",
  getActivityAndScore: "/ActivityLogs/GetActivityAndScore",

  // general setting
  getCompanySetting: "/GeneralSettings/Detail/",
  updateCompanySetting: "/GeneralSettings/Update",
  createCompanySetting: "/GeneralSettings/Create",
  getLengthFooterText: "/GeneralSettings/LengthFooterText",
  getPrioritizeOwner: "/GeneralSettings/GetPrioritizeOwners",
  updatePrioritizeOwner: "/GeneralSettings/UpdatePrioritizeOwners",
  getTimeZones: "/GeneralSettings/GetTimeZone/",
  updateTimeZone: "/GeneralSettings/UpdateTimeZone/",
  getCompanyColors: "/GeneralSettings/GetCompanyColor",
  createCompanyColor: "/GeneralSettings/CreateCompanyColor",
  updateCompanyColor: "/GeneralSettings/UpdateCompanyColor",
  deleteCompanyColor: "/GeneralSettings/DeleteCompanyColor/",
  getCompanyBranding: "/Branding/Get",
  saveCompanyBranding: "/Branding/Save",


  // lookup
  getJAWorkTypes: "/Lookup/Jobadder/WorkTypes",
  getJARatings: "/Lookup/Jobadder/Ratings",
  getTagSuggestions: "/Lookup/GetTagSuggestion/",
  getPlacementStatuses: "/Lookup/JobAdder/PlacementStatuses",
  getPlacementTypes: "/Lookup/AtsProvider/PlacementTypes",
  getInterviewTypes: "/Lookup/AtsProvider/InterviewTypes",
  getJobTypes: "/Lookup/AtsProvider/JobTypes",
  getJobs: "/Lookup/AtsProvider/Jobs",
  getJobLocations: "/Lookup/AtsProvider/Locations",
  getCandidateCurrentPositions: "/Lookup/AtsProvider/CandidateCurrentPositions",
  getCandidateCurrentEmployers: "/Lookup/AtsProvider/CandidateCurrentEmployers",
  getCandidatePostalCodes: "/Lookup/AtsProvider/CandidatePostalCodes",
  getCandidateCities: "/Lookup/AtsProvider/CandidateCities",
  getCandidateStates: "/Lookup/AtsProvider/CandidateStates",
  getCandidateSources: "/Lookup/Jobadder/Sources",
  getCandidateContactMethods: "/Lookup/AtsProvider/CandidateContactMethods",
  getClientPositions: "/Lookup/AtsProvider/ClientPositions",
  getClientCities: "/Lookup/AtsProvider/ClientCities",
  getClientStates: "/Lookup/AtsProvider/ClientStates",
  getClientPostalCodes: "/Lookup/AtsProvider/ClientPostalCodes",
  getApplicationStatuses: "/Lookup/JobAdder/ApplicationStatuses",
  getJobStatuses: "/Lookup/JobAdder/JobStatuses",
  getCandidateAttachmentCategories: "/Lookup/JobAdder/CandidateAttachmentCategories",
  getCandidateAttachmentCategoriesDefaults: "/Lookup/JobAdder/CandidateAttachmentCategories/Defaults",
  getContactAttachmentCategories: "/Lookup/JobAdder/ContactAttachmentCategories",
  getContactAttachmentCategoriesDefaults: "/Lookup/JobAdder/ContactAttachmentCategories/Defaults",


  getSkillCategories: "/Lookup/Skills/Categories",
  getSkillSubCategories: "/Lookup/Skills/SubCategories",
  getSkills: "/Lookup/Skills",
  getCompanies: "/Lookup/JobAdder/Companies",

  // getJASources: "/Lookup/Jobadder/Sources",
  getJACandidateStatuses: "/Lookup/Jobadder/CandidateStatuses",
  getJASalutations: "/Lookup/Jobadder/Salutations",
  getJAWorkTypesPublic: "/Lookup/Jobadder/WorkTypesPublic",
  getJARatingsPublic: "/Lookup/Jobadder/RatingsPublic",
  getJACandidateStatusesPublic: "/Lookup/Jobadder/CandidateStatusesPublic",
  getJACandidateNoteStatuses: "/Lookup/Jobadder/CandidateNoteStatuses",
  getJAClientStatuses: "/Lookup/Jobadder/ClientStatuses",
  getJAClientNoteStatuses: "/Lookup/Jobadder/ClientNoteStatuses",
  getJACountries: "/Lookup/Jobadder/Countries",
  getJACountriesPublic: "/Lookup/Jobadder/CountriesPublic",
  getJobApplicationSources: "/Lookup/Jobadder/JobApplicationSources",
  getCustomFieldsPublic: "Lookup/Candidate/CustomFieldsPublic",

  // link trackers for trigger
  getActivityLogName: "/ActivityLogs/GetActivityLogName",
  getClientActivityLogName: "/ActivityLogs/GetClientActivityLogName",

  //email campaign
  addEmailCampaign: "/EmailCampaigns/Create",
  updateEmailCampaign: "/EmailCampaigns/Update",
  getEmailCampaignDetail: "/EmailCampaigns/Detail/",
  getListEmailCampaign: "/EmailCampaigns/List",
  deleteEmailCampaign: "/EmailCampaigns/Delete/",
  getAllEmailCampaign: "/EmailCampaigns/GetAll/",
  getEmailCampaignLinks: "/EmailCampaigns/GetEmailCampaignLink/",
  IsEmailCampaignUsedInAutomation: "/EmailCampaigns/IsEmailCampaignUsedInAutomation/",

  copyEmailToExisting: "/EmailCampaigns/CreateCopy",
  getEmailCampaignIsNameInUse: "/EmailCampaigns/GetIsNameInUse",
  postEmailCampaignSaveAsNew: "/EmailCampaigns/SaveAsNew",

  //email template
  copyEmailToTemplate: "/EmailTemplates/Create",
  getListEmailTemplate: "/EmailTemplates/List",
  getEmailTemplateDetail: "/EmailTemplates/Detail/",
  deleteEmailTemplate: "/EmailTemplates/Delete/",
  updateEmailTemplate: "/EmailTemplates/Update",
  getEmailTemplateIsNameInUse: "/EmailTemplates/GetIsNameInUse",
  emailTemplateSetShowToRecruiter: "/EmailTemplates/SetShowToRecruiter",

  //Save Rows
  getListSaveRow: "/EmailTemplates/ListSaveRow",
  getSaveRow: "/EmailTemplates/GetSaveRow/",
  createSaveRow: "/EmailTemplates/CreateSaveRow",
  updateSaveRow: "/EmailTemplates/UpdateSaveRow",
  deleteSaveRow: "/EmailTemplates/DeleteSaveRow/",

  //ATS Field
  getAtsField: "/AtsFields/GetAtsFields",
  getContactAtsField: "/AtsFields/GetContactAtsFields",
  getLandingPageAtsField: "/AtsFields/GetLandingPageAtsFields",
  setAtsField: "/AtsFields/SetFieldState",
  setAllAtsField: "/AtsFields/SetAllFieldState",
  customFields: "/AtsFields/Candidate/CustomFields",
  customFieldsContact: "/AtsFields/Contact/CustomFields",
  getAtsCategorisedFields: "/AtsFields/GetAtsCategorisedFields",

  // Campaign assistant (AI campaign builder)
  campaignAiChat: "/CampaignAi/Chat",
  campaignAiSaveDraft: "/CampaignAi/SaveDraft",
  campaignAiSessionForAutomation: "/CampaignAi/Session/ForAutomation/",
  campaignAiSession: "/CampaignAi/Session/",
  campaignAiLinkSession: "/CampaignAi/LinkSession",
  campaignAiAvailability: "/CampaignAi/Availability",
  campaignAiStepSaved: "/CampaignAi/Session/StepSaved",

  // Automation
  getAutomations: "/Automations/GetAutomations",
  getAutomationDetail: "/Automations/",
  addAutomation: "/Automations/CreateAutomation",
  deleteAutomation: "/Automations/",
  setAutomationState: "/Automations/SetAutomationState",
  updateAutomation: "/Automations/Update",
  getTriggerMatchesNumber: "/Automations/GetMatchesNumber",
  getCachedTriggerMatchesNumber: "/Automations/GetCachedMatchesNumber",
  getCandidateCustomFields: "/CandidateCustomFields/GetCandidateCustomField",
  automationSaveAsExisting: "/Automations/CreateCopy",
  getAutomationAudienceList: "/Audiences/List",
  getAutomationAudienceClientList: "/AudienceClients/List",
  getClientCustomFields: "/ClientCustomFields",
  getPlacementCustomFields: "/PlacementCustomFields/GetPlacementCustomField",
  getJobCustomFields: "/JobCustomFields/GetJobCustomField",
  getApplicationCustomFields: "/ApplicationCustomFields/GetApplicationCustomField",
  getIsNameInUse: "/Automations/GetIsNameInUse",
  postSaveAsNew: "/Automations/SaveAsNew",

  //Domain Authentication
  getCompanyDomain: "/CompanyDomain/Detail",
  getCompanyDomainDetailById: "/CompanyDomain/GetDomainDetailById",
  addCompanyDomain: "/CompanyDomain/Register",
  verifyCompanyDomain: "/CompanyDomain/Verify",
  setDomainDefault: "/CompanyDomain/SetDefaultDomain",
  deleteCompanyDomain: "/CompanyDomain/Delete/",

  //Shortlink
  getShortlinkByToken: "/LinkTracker/GetOriginalUrl/",
  getShortlinkClientByToken: "/LinkTracker/OriginalUrl/Client/",
  getConvertLink: "/Campaign/ShortenLink",
  getBaitlink: "/LinkTracker/BaitLink/",

  //survey
  getListSurveys: "/Surveys/GetSurveys",
  getSurveyTags: "/Surveys/GetSurveyTags",
  getSurveyDetail: "/Surveys/",
  getSurveyByToken: "/Surveys/GetSurveyByToken/",
  getSurveyClientByToken: "Surveys/Client/",
  addSurvey: "/Surveys/CreateSurvey",
  deleteSurvey: "/Surveys/",
  setSurveyState: "/Surveys/SetSurveyState",
  submitSurvey: "/Surveys/SubmitSurvey/",
  submitSurveyClient: "/Surveys/Client/Submit/",
  updateSurvey: "/Surveys/UpdateSurvey/",
  getAllSurveys: "/Surveys/GetAll",
  getSurveyIsNameInUse: "Surveys/GetIsNameInUse",
  postSurveySaveAsNew: "Surveys/SaveAsNew",

  //survey template
  getSurveyTemplateDetail: "/SurveyTemplates/",
  getSurveyTemplateList: "/SurveyTemplates/GetSurveyTemplates",
  saveSurveyToTemplate: "/SurveyTemplates/Create",
  updateSurveyTemplate: "/SurveyTemplates/Update",
  deleteSurveyTemplate: "/SurveyTemplates/Delete/",
  saveSurveyToExisting: "/Surveys/CreateCopy",

  // Recruiter
  getCandidateOwners: "/CandidateOwners/GetCandidateOwners",
  updateDefaultOwners: "/CandidateOwners/SetDefaultCandidateOwner",
  updateDefaultJobOwners: "/CandidateOwners/SetDefaultJobOwner",

  //Email footer
  getEmailFooterSetting: "/EmailFooterTemplates/Get",
  updateEmailFooterSetting: "/EmailFooterTemplates/Update",
  saveSendUnsubscribeNoteStatus:"/EmailFooterTemplates/SaveSendUnsubscribeNoteStatus",

  //Automation Templates
  getAutomationTemplates: "/AutomationTemplates/GetAutomationTemplates",
  automationSaveAsTemplate: "/AutomationTemplates/Create",
  getAutomationTemplateDetail: "/AutomationTemplates/",
  updateAutomationTemplate: "/AutomationTemplates/Update",
  deleteAutomationTemplates: "/AutomationTemplates/",
  automationSetShowToRecruiter: "/AutomationTemplates/SetShowToRecruiter",
  getIsTemplateNameInUse: "/AutomationTemplates/GetIsNameInUse",

  //Web activity tracker
  getWebActivityTrackerSetting: "/WebActivityTracking",
  updateWebActivityTrackerSetting: "/WebActivityTracking/Update",
  deleteWebActivityTrackerSetting: "/WebActivityTracking/Delete",

  //Segmentation
  getAtsProviderUsers: "/Segmentation/GetAtsProviderUsers",
  getAtsProviderOffices: "/Segmentation/GetAtsProviderOffices",
  getAtsProviderGroups: "/Segmentation/GetAtsProviderGroups",

  //Analytics
  getAnalytics: "/Analytics",
  getPlacementsDashboard: "/Placements",

  //Skills
  getCandidateSkillsHierarchy: "/CandidateSkills/Hierarchy",

  //Landing Page
  getAllLandingPages: "/LandingPages",
  getLandingPageById: "/LandingPages/",
  deleteLandingPage: "/LandingPages/",
  updateLandingPage: "/LandingPages/Update",
  createLandingPage: "/LandingPages/Create",
  duplicateLandingPage: "/LandingPages/",
  saveAsTemplate: "/LandingPages/SaveAsTemplate",
  getLandingPageIsNameInUse: "/LandingPages/GetIsNameInUse",



  //template landing page
  getTemplateLandingPages: "/LandingPageTemplates",
  getTemplateLandingPageById: "/LandingPageTemplates/",
  deleteTemplateLandingPage: "/LandingPageTemplates/",
  updateTemplateLandingPage: "/LandingPageTemplates/Update",
  createTemplateLandingPage: "/LandingPageTemplates/Create",
  duplicateTemplateLandingPage: "/LandingPageTemplates/DuplicateWithName",
  saveAsLandingPage: "/LandingPageTemplates/SaveAsLandingPage",
  getTemplateLandingPageIsNameInUse: "/LandingPageTemplates/GetIsNameInUse",

  //Subdomains
  getSubdomains: "/CompanySubdomain/GetAll",
  createSubdomain: "/CompanySubdomain/Register",
  updateSubdomain: "/CompanySubdomain/Update",
  deleteSubdomain: "/CompanySubdomain/",
  verifySubdomain: "/CompanySubdomain/Check",

  //custom subdomain
  getCustomSubdomains: "/CompanySubdomain/CustomDomain",
  getCustomSubdomainById: "/CompanySubdomain/CustomDomain/",
  createCustomSubdomain: "/CompanySubdomain/CustomDomain/Register",
  deleteCustomSubdomain: "/CompanySubdomain/CustomDomain/",
  verifyCustomSubdomainStatus:"/CompanySubdomain/CustomDomain/VerificationStatus",
  // ROI-161: followed by "{customDomainName}/Certificate" (or ".../Certificate/History")
  customDomainCertificate: "/CompanySubdomain/CustomDomain/",

  //Forms
  getForms: "/Forms",
  getActiveForms: "/Forms/ListActive",
  getAllForms: "/Forms/GetAll/",
  createForm: "/Forms",
  getFormById: "/Forms/",
  updateForm: "/Forms/",
  deleteForm: "/Forms/",
  checkFormName: "/Forms/CheckName",
  duplicateForm: "/Forms/",
  duplicateFormWithName: "/Forms/",
  getFormByFormId: "/Forms/GetFormByFormId/",
  submitForm: "/Forms/SubmitForm",

  //Form Templates
  getFormTemplates: "/FormTemplates",
  createFormTemplate: "/FormTemplates",
  getFormTemplateById: "/FormTemplates/",
  updateFormTemplate: "/FormTemplates/",
  deleteFormTemplate: "/FormTemplates/",
  checkFormTemplateName: "/FormTemplates/CheckName",
  duplicateFormTemplate: "/FormTemplates/DuplicateWithName",


  //Form metrics
  getFormMetrics: "Reports/Form/Completion/Detail/",
  getFormTotalCompletion: "Reports/Form/TotalCompletion/",
  getFormCompletionMetrics: "/Reports/Form/",
  getFormCompletionResponses: "/Reports/Form/CompletionResponses/",


  //Landing Page metrics
  getLandingPageMetrics: "Reports/LandingPage/Completion/Detail/",
  getLandingPageTotalCompletion: "Reports/LandingPage/TotalCompletion/",
  getLandingPageCompletionMetrics: "/Reports/LandingPage/",


  //Bee Auth token
  getBeeAuthToken: "/Beefree/Auth",
  getBeeFileManagerAuthToken: "/Beefree/FileManager/Auth",
  getBeePageBuilderAuthToken: "/Beefree/PageBuilder/Auth",


  // Feature Flag
  getFeatureFlags: "/Flagr/",

  //Bee Templates
  getBeeTemplates: "/Beefree/Catalog/Templates",
  getBeeTemplateById: "/Beefree/Catalog/Templates/",

  //Bee Categories
  getBeeCategories: "/Beefree/Catalog/Categories",
  getBeeCategoryById: "/Beefree/Catalog/Categories/",

  //Bee HTML Import
  beeHtmlImport: "/Beefree/HtmlImport",

  //Onboarding / Welcome Dashboard
  getSetupStatus: "/Setup/GetStatus",
  updateSetupStep: "/Setup/UpdateStep",
};

export default ApiUrl;
